// TODO: use their version when merge to main branch

const selectors = {
  cartDrawerTrigger: '.new-layout-header__actions-cart',
  cartDrawerContainer: '#shopify-section-cart-drawer',
  cartDrawerClose: '.cart-drawer__header-details__close',
  cartDrawerUnderlay: '.cart-drawer__underlay',
};

export const showCartSideDraw = () => {
  // Close quickshop if it's open
  const quickshop = document.querySelector('#quickshop-component');
  if (quickshop && quickshop.classList.contains('active')) {
    quickshop.classList.remove('active');
    // Dispatch event to notify quickshop to close
    document.dispatchEvent(new CustomEvent('quickshop:close'));
  }

  document.body.classList.add('scroll-locked');
  document.documentElement.classList.add('scroll-locked');
  $(selectors.cartDrawerContainer).addClass('active');
  document.dispatchEvent(new CustomEvent('cartDrawer:open'));
}

export const hideCartSideDraw = () => {
  document.body.classList.remove('scroll-locked');
  document.documentElement.classList.remove('scroll-locked');
  $(selectors.cartDrawerContainer).removeClass('active');
  document.dispatchEvent(new CustomEvent('cartDrawer:close'));
}

const CartDrawer = () => {
  if (!$(selectors.cartDrawerTrigger).hasClass('disable--cart-drawer')) {
    $(selectors.cartDrawerTrigger).on('click', () => {
      showCartSideDraw();
    });
    $(`${selectors.cartDrawerClose}, ${selectors.cartDrawerUnderlay}`).on('click', () => {
      hideCartSideDraw();
    });
  }
};
export default CartDrawer;